import {
  ActionSheet,
  Button,
  Card,
  Container,
  Grid,
  Section,
  Stack,
  useActionSheetProvider,
} from "@storoey/sui";
import { createFileRoute, redirect, useNavigate } from "@tanstack/solid-router";
import { onMount } from "solid-js";
import { useNavbar } from "../../../contexts/RootContext";
import { databaseService } from "../../../services/database.service";

async function loadTemplate(templateId: string) {
  const id = Number(templateId);
  if (Number.isNaN(id)) {
    throw redirect({
      to: "/",
    });
  }

  const template = await databaseService.getTemplate(id);

  if (!template) {
    throw redirect({
      to: "/",
    });
  }
  // await new Promise((resolve) => setTimeout(resolve, 5000));
  return template;
}

export const Route = createFileRoute("/templates/$templateId/")({
  staticData: {
    backLabel: "Maler",
    backTo: "/templates",
  },
  loader: async ({ params: { templateId } }) => loadTemplate(templateId),
  component: RouteComponent,
});

function RouteComponent() {
  const template = Route.useLoaderData();
  const actionSheet = useActionSheetProvider();
  const { setTitle } = useNavbar();
  const navigate = useNavigate();

  onMount(() => {
    setTitle(template().title);
  });

  const handleUseTemplate = async () => {
    if (!template().id) {
      return;
    }

    const { id } = await databaseService.createNewForm(
      template().id!,
      template().title
    );

    navigate({ to: "/history/" + id });
  };

  const handleDelete = async () => {
    if (!template().id) {
      return;
    }

    await databaseService.deleteTemplate(template().id!);
    navigate({ to: "/templates", from: "/templates/$templateId" });
  };

  return (
    <>
      <Section padding="md">
        <Container>
          <Stack>
            <Card elevation={200}>
              <Card.Content>
                <Grid columns={2} minColWidth="200px" gap="0">
                  <div>
                    <Card.Title>{template().title}</Card.Title>
                    <Card.Text>
                      {Intl.DateTimeFormat("no-NB", {
                        dateStyle: "medium",
                        timeStyle: "medium",
                      }).format(template().createdAt)}
                    </Card.Text>
                  </div>
                  <Stack direction="row" align="center" justify="end">
                    <Button onClick={handleUseTemplate}>Bruk</Button>
                  </Stack>
                </Grid>
              </Card.Content>
              <Card.Actions>{template().title}</Card.Actions>
              <Card.Actions align="end">
                <Button
                  variant="outline"
                  color="red"
                  onClick={actionSheet.open}
                >
                  Slett
                </Button>
              </Card.Actions>
            </Card>
          </Stack>
        </Container>
      </Section>
      <ActionSheet isOpen={actionSheet.isOpen} close={actionSheet.close}>
        <ActionSheet.Content
          title="Er du sikker?"
          text="Denne handlingen kan ikke reverseres."
        >
          <ActionSheet.Button onClick={handleDelete} danger>
            Slett
          </ActionSheet.Button>
        </ActionSheet.Content>
      </ActionSheet>
    </>
  );
}
